import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import FileService from "../../services/fileService";

const Avatar = ({ user, avatar, size, style }) => {
  const [imageSrc, setImageSrc] = useState(null);
  const initials = user.full_name
    ? user.full_name.split(" ").map((n) => n.charAt(0))
    : [];

  const token = localStorage.getItem("grav_token");
  const fileName = avatar?.replace("https://gfs-redkeep.s3.amazonaws.com/", "");

  useEffect(() => {
    const fetchImage = async () => {
      const imageSource = await FileService.getFileWithToken(fileName, token);
      setImageSrc(imageSource);
    };
    if (token.length && fileName) {
      fetchImage();
    }
  }, [token, fileName]);

  return (
    <div className={`avatar ${size}`} style={style}>
      {avatar ? <img src={imageSrc} alt="" /> : null}

      <div className="user-icon">
        <span>{initials.join("")}</span>
      </div>
    </div>
  );
};

Avatar.propTypes = {
  user: PropTypes.object,
  avatar: PropTypes.string,
  size: PropTypes.string,
  style: PropTypes.string
};

Avatar.defaultProps = {
  user: {},
  avatar: ""
};

export default Avatar;
